import { ReactNode, useMemo } from 'react';
import { SharedEditorRoute } from '../../router/restricted-routes-wrapper.tsx';
import cn from 'classnames';
import { useThemeContext } from '@utils/hooks/use-theme-context.ts';
import { css, StyleSheet } from 'aphrodite';
import TopNavSharedPage from '@components/layout/navbar/top-nav-shared-page.tsx';
import PageErrorBoundary from '@components/layout/page-error-boundary.tsx';

interface Props {
  layoutType?: 'main' | 'editor';
  children: ReactNode;
}

export default function SharePageWrapper(props: Props) {
  const { getColour } = useThemeContext();

  const styles = useMemo(
    () =>
      StyleSheet.create({
        main: {
          backgroundColor: getColour('baseLayer'),
          color: getColour('normalText')
        }
      }),
    [getColour]
  );

  return (
    <SharedEditorRoute>
      {props.layoutType === 'editor' ? (
        <>
          <TopNavSharedPage />
          <div
            className={cn(
              'w-full flex flex-row overflow-y-auto',
              css(styles.main)
            )}
            style={{
              height: 'calc(100vh - 4rem)'
            }}
          >
            <main className={cn('h-full w-full flex flex-col')}>
              <PageErrorBoundary>{props.children}</PageErrorBoundary>
            </main>
          </div>
        </>
      ) : (
        <>
          <TopNavSharedPage />
          <div
            className={cn('w-full flex flex-row')}
            style={{
              height: 'calc(100vh - 4rem)'
            }}
          >
            <main
              className={cn(
                'lg:px-8 lg:py-2',
                'sm:px-6 sm:py-4',
                'max-h-full w-full overflow-y-auto flex flex-col gap-y-2',
                css(styles.main)
              )}
            >
              <PageErrorBoundary>{props.children}</PageErrorBoundary>
            </main>
          </div>
        </>
      )}
    </SharedEditorRoute>
  );
}
